module.exports = __webpack_public_path__ + "img/6.06c08762.jpg";